import React from 'react';
import { withRouter } from 'react-router-dom';
import { TenantAppsLink } from '../../routes/routes';

/* Result */
import Result from 'iotera-base/result'

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'

/* Routes */
import { RedirectToLogin, domainIsTenant as dit } from '../../routes/routes'

/* Json */
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json'

/* Redux */
import { connect } from 'react-redux';

/* Credentials Token */
import { removeTokenDit } from '../../auth/token'

import { SizeMe } from 'react-sizeme';
import IoteraClass from '../../lib/components/react/react-class';
import Skeleton from '@material-ui/lab/Skeleton';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const WKEY = "APPLICATION_LIST";
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

class ApplicationCard extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    }
  }
  toggle = (e, str) => {
    const _this = this
    setTimeout(() =>
      _this.setState({
        modal: true,
      })
      , 0)
    setTimeout(() =>
      _this.dismissLoading(), 1500);
  }

  dismissLoading() {
    setTimeout(() =>
      this.setState({ modal: false })
      , 1500)
  }

  gotoApps = (domain) => {
    this.props.history.push(`../${domain}`)
  }

  render() {
    const _this = this
    const _props = _this.props
    let showSkeleton = safeDeepGetWithType(_props, ['show'], false)
    let applicationCards = []
    let data = safeDeepGet(_props, ['data'], []);
    let length = data.length;
    let currWidth = safeDeepGetWithType(_props, ['displaySize', 'width'], 0);
    let customCol = currWidth <= 996 ? "io-col-md-6" : "io-col-md-3"
    if (length > 0) {
      for (let i = 0; i < data.length; i++) {
        let description = safeDeepGetWithType(data, [i, 'description'], '')
        applicationCards.push(
          <div key={i} className={customCol} onClick={() => _this.gotoApps(data[i].domain)}>
            <div className="io-card io-card__shadow-sm io-card__direct mb-6" style={{ height: '200px' }}>
              <div className="card-body card-body__compact text-center ">
                <div className="io-row align-items-center h-100">
                  <div className="io-col">
                    <div className="embed-responsive embed-responsive-1by1 mx-auto mb-4" style={{ width: '56px' }}>
                      <div className="embed-responsive-item p-3 bg-light rounded-circle">
                        <img src={'https://i.imgur.com/PRej5fl.png'} alt="Application icon" className="image__contain" />
                      </div>
                    </div>
                    <h6 className="mb-2 font-weight-normal" style={{ textDecoration: 'none' }}>{data[i].name}</h6>
                    <h5 className="font-weight-normal text-gray-300 mb-0" style={{ textDecoration: 'none' }}>
                      {description}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
    }
    return (
      <div className="io-container mt-12">
        <div className="io-row align-items-center mb-4">
          <div className="io-col">
            <h3 className="mt-4 font-weight-normal">List of Application</h3>
            <h6 className="text-gray-300 font-weight-normal">Manage application</h6>
          </div>
          {/* Disable create application from UI for some time */}
          {/* <div className="io-col-auto">
            <TenantAppsLink to={'add'}  >
              <div className="io-btn io-btn-primary">
                Create Application
              </div>
            </TenantAppsLink>
          </div> */}
        </div>
        <div className='io-row' style={{ margin: '0 -5px' }}>
          {showSkeleton ?
            <div className={customCol} style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 10 }}>
              <Skeleton variant="rect" width={'100%'} height={225.75} />
            </div>
            :
            applicationCards
          }
        </div>
      </div>
    )
  }
}


class Applications extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: { path: "/service/web/application/list" },
        wcallback: {
          started: function (id) {
            // TODO Loading
          },
          finished: function (id, result) {
            _this.setState({
              loading: false
            })
          }
        }
      }
    );
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props)
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const data = safeDeepGet(_props, ['items'], []);
    const { loading } = _state;
    return (
      <div >
        <SizeMe>{({ size }) =>
          <ApplicationCard {..._props} data={data} displaySize={size} show={loading} />
        }
        </SizeMe>
      </div>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    items: wSelector.getSoleInitMappedRPayload(state, 'applications')
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Applications));